import * as React from 'react';
import { IChat, LanguageLevelEnum } from '../api/ChatApi';

interface IChatListContextType {
    chatList: IChat[];
    setChatList: (newChatList: IChat[]) => void;
    isLoading: boolean;
    setIsLoading: (isLoading: boolean) => void;
    showSkeleton: boolean;
    setShowSkeleton: (isLoading: boolean) => void;
    selectedChat: IChat;
    setSelectedChat: (newChat: IChat) => void;
};

const ChatListInitialContext = {
    chatList: [], setChatList: () => null,
    isLoading: false, setIsLoading: () => null,
    showSkeleton: false, setShowSkeleton: () => null,
    selectedChat: { id: 0, language_level: LanguageLevelEnum.Hsk1, first_line: '',}, setSelectedChat: () => null
};

const ChatListContext = React.createContext<IChatListContextType>(ChatListInitialContext);
export default ChatListContext

export const ChatListProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [chatList, setChatList] = React.useState<IChat[]>([]);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [showSkeleton, setShowSkeleton] = React.useState<boolean>(false);
    const [selectedChat, setSelectedChat] = React.useState<IChat>({ id: 0, language_level: LanguageLevelEnum.Hsk1, first_line: ''});

    const contextValue = React.useMemo(() => ({
        chatList,
        setChatList,
        isLoading,
        setIsLoading,
        showSkeleton,
        setShowSkeleton,
        selectedChat,
        setSelectedChat,
    }), [chatList, isLoading, showSkeleton, selectedChat]);

    return (
        <ChatListContext.Provider value={contextValue}>
            {children}
        </ChatListContext.Provider>
    );
};